const projectIdCreate = (state = true, action) => {

    switch (action.type) {

        case "IDCREATE":

            return !state

        default:

            return state

    }

}

export default projectIdCreate